<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="26" height="19" viewBox="0 0 26 19" fill="none">
		<path
			d="M2.54207 12.1593C1.81931 12.0401 1.81931 10.9872 2.54207 10.8482C5.14012 10.3912 7.21074 8.36487 7.77723 5.74253L7.8163 5.54386C7.97258 4.82868 8.98835 4.80881 9.14463 5.54386L9.20323 5.78226C9.78926 8.38474 11.8599 10.3912 14.4579 10.8482C15.1807 10.9673 15.1807 12.0401 14.4579 12.1593C11.8599 12.6162 9.78926 14.6227 9.20323 17.2252L9.14463 17.4636C8.98835 18.1788 7.97258 18.1788 7.8163 17.4636L7.77723 17.2649C7.21074 14.6426 5.14012 12.6162 2.54207 12.1593Z"
			:stroke="color"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.417 6.50717C14.861 6.41548 14.861 5.60555 15.417 5.49858C17.4155 5.1471 19.0083 3.58836 19.444 1.57117L19.4741 1.41836C19.5943 0.868215 20.3757 0.852933 20.4959 1.41836L20.5409 1.60174C20.9917 3.60364 22.5845 5.1471 24.583 5.49858C25.139 5.59027 25.139 6.41548 24.583 6.50717C22.5845 6.85865 20.9917 8.40211 20.5409 10.404L20.4959 10.5874C20.3757 11.1375 19.5943 11.1375 19.4741 10.5874L19.444 10.4346C19.0083 8.41739 17.4155 6.85865 15.417 6.50717Z"
			:stroke="color"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'AiSparkIcon',
	props: {
		color: {
			type: String,
			default: '#ffffff',
		},
	},
});
</script>
